import script from "./MallOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./MallOrders.vue?vue&type=script&setup=true&lang=js"

import "./MallOrders.vue?vue&type=style&index=0&id=1109ae55&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1109ae55"]])

export default __exports__